export default __webpack_public_path__ + "static/media/fidelity-computer-crime-cropped.30380bfe.jpg";